import React, {useState, useEffect} from "react";
import { FaHome, FaUser, FaCogs, FaBriefcase, FaGraduationCap, FaEnvelope, FaFileAlt, FaMoon, FaSun } from 'react-icons/fa';
import { Link, Outlet } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import resume from '../assets/imgs/Tehzeeb_Jahan_MERN_Developer.jpeg';

const Navbar = () => {
    const [navOpen, setNavOpen] = useState(false);
    const [isSticky, setIsSticky] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [darkMode, setDarkMode] = useState(false);

    useEffect(() => {
      const savedMode = localStorage.getItem("darkMode");
      if (savedMode === "true") {
        setDarkMode(true);
        document.body.classList.add("dark-mode");
      }
    }, []);

    useEffect(() => {
      if (darkMode) {
        document.body.classList.add("dark-mode");
      } else {
        document.body.classList.remove("dark-mode");
      }
      localStorage.setItem("darkMode", darkMode);
    }, [darkMode]);

    useEffect(() => {
      const handleScroll = () => {
        if (window.scrollY > 20) {
          setIsSticky(true);
        } else {
          setIsSticky(false);
        }
      };

      window.addEventListener('scroll', handleScroll);

      return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleTop = () => setIsVisible(window.scrollY > 300);

    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    useEffect(() => {
      window.addEventListener('scroll', handleTop);
      return () => window.removeEventListener('scroll', handleTop);
    }, []);

    function resetCursor() {
      const allDots = document.querySelectorAll(
        ".cursor-dot, .cursor-dot1, .cursor-dot2, .cursor-dot3, .cursor-dot4, .cursor-dot5"
      ); 
      const blinkDot = document.querySelector(".cursor-blink");
      allDots.forEach(dot => dot.style.display = "block");
      blinkDot.style.display = "none";
    }

    const openModal = () => setShowModal(true);

    const closeModal = () => {
      setShowModal(false);
      resetCursor();
    };

    return (
    <>
    <nav className={`custom-navbar ${isSticky ? 'affix' : ''}`} data-spy="affix" data-offset-top="20">
      <div className="container">
        <Link className="logo" to="/">TJ Web Studio</Link>
        <ul className={`nav ${navOpen ? 'show' : ''}`}>
          <li className="item"><HashLink smooth className="link active-link" to="/#home"><FaHome title="Home" /></HashLink></li>
          <li className="item about"><HashLink smooth className="link" to="/#about"><FaUser title="About" /></HashLink></li>
          <li className="item services"><Link className="link" to="/services-page"><FaCogs title="Sevices" /></Link></li>
          <li className="item project"><Link className="link" to="/allProjects"><FaBriefcase title="All Projects" /></Link></li>
          <li className="item education"><HashLink smooth className="link" to="/#education"><FaGraduationCap title="Education" /></HashLink></li>
          <li className="item contact"><HashLink smooth className="link" to="/#contact"><FaEnvelope title="Contact" /></HashLink></li>
          <li className="item resume">
            <button onClick={openModal} className="link border-0 bg-transparent">
              <FaFileAlt title="Resume"/>
            </button>
          </li>

          <li className="item ml-md-3 mode">
            <button onClick={() => setDarkMode(!darkMode)} className="btn btn-primary shadow py-2">
              {darkMode ? <FaSun title="Light Mode"/> : <FaMoon title="Dark Mode"/>}
            </button>
          </li>

        </ul>
        <div className="nav-availability">
          <span className="dot"></span>
            Available for Freelance Projects
        </div>
        <a 
          href="/" 
          id="nav-toggle" 
          className={`hamburger hamburger--elastic ${navOpen ? 'is-active' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            setNavOpen(!navOpen);
          }}
        >
          <div className="hamburger-box">
            <div className="hamburger-inner"></div>
          </div>
        </a>
      </div>
    </nav>

    {showModal && (
      <div className='modal-overlay' onClick={closeModal}>
        <div className='modal-content' onClick={(e) => e.stopPropagation()}>
            <div className='modal-head m-4'>
            <h1 className='section-title'>Resume</h1>
            <button className='close-button' onClick={closeModal}>&times;</button>
          </div>
          <div className='modal-img'>
            <center>
              <img 
                alt="Resume"
                src={resume}
                className="border"
              />
            </center>
          </div>
        </div>
      </div>
    )}

    {/* Back-to-top button */}
    {isVisible && (
      <button onClick={scrollToTop} className="go-to-top">
        <i className="fa fa-angle-up" aria-hidden="true"></i>
      </button>
    )}

    <Outlet />

    </>
    );
};

export default Navbar;